export const RELATED_CATEGORY_DISPLAY_LIMIT = 5;

export const RELATED_CATEGORIES_KEYS = [
  'relatedCategories1',
  'relatedCategories2',
  'relatedCategories3',
] as const;
